<div *ngIf="!isSecondary"
     class="layout-row layout-align-start-center bringoz-status-tag"
     [ngClass]="status"
     [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover" container="body">

  <span class="br-caption-1 font-weight-600">
      {{isSmall ? ('STATUS_TAG.' + status | translate) : status | translate}}
    </span>

  <span *ngIf="extraText" class="margin-left-5 br-caption-1 font-weight-400">
      - {{extraText | translate}}
    </span>

    <ng-template #tooltipTmpl>
      <div layout="row">
        <span>{{status | translate}}</span>
        <span *ngIf="extraTooltipText" class="margin-left-5">- {{extraTooltipText | translate}}</span>
      </div>
    </ng-template>
</div>

<div *ngIf="isSecondary" class="secondary bringoz-status-tag layout-row layout-align-start-center"
     [ngClass]="status"
     [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover">

    <span class="br-caption-1 font-weight-600">
      {{isSmall ? ('STATUS_TAG.' + status | translate) : status | translate}}
    </span>

  <span *ngIf="extraText" class="margin-left-5 br-caption-1 font-weight-400">
      - {{extraText | translate}}
  </span>

  <ng-template #tooltipTmpl>
    <div layout="row">
      <span>{{status | translate}}</span>
      <span *ngIf="extraTooltipText" class="margin-left-5">- {{extraTooltipText | translate}}</span>
    </div>
  </ng-template>
</div>
